import { useContext, useMemo } from "react";

import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";

import { MetricsExplorerContext } from "./metrics-explorer-provider";
import { MetricsExplorerStateContext } from "./metrics-explorer-state-provider";
import { type TileFilter } from "./types";

export const useMetricsExplorerContext = () => {
  const context = useContext(MetricsExplorerContext);

  if (!context) {
    throw new Error(
      "useMetricsExplorerContext can only be used inside MetricsExplorerProvider",
    );
  }

  return context;
};

export const useMetricsExplorerStateContext = () => {
  const context = useContext(MetricsExplorerStateContext);

  if (!context) {
    throw new Error(
      "useMetricsExplorerStateContext can only be used inside MetricsExplorerStateProvider",
    );
  }

  return context;
};

export const useQuickFilterOptions = () => {
  const { value: breakdownConfigs } = useSalesBreakdownConfigs();

  return useMemo(() => {
    const platformBreakdown = breakdownConfigs.find(
      (e) => e.key === "Platform (Northbeam)",
    );

    const options: TileFilter[] = [];

    [
      "Facebook Ads",
      "Google Ads",
      "Amazon - Ads and Organic",
      "TikTok",
      "Snapchat Ads",
      "AppLovin",
    ].forEach((platform) => {
      if (!platformBreakdown) {
        return;
      }

      if (platformBreakdown.choices.find((e) => e.label === platform)) {
        options.push({ breakdown: platformBreakdown.key, value: platform });
      }
    });

    return options;
  }, [breakdownConfigs]);
};
